import moment from 'moment';

export const initIntercom = (employee: $TSFixMe, company: $TSFixMe) => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message
  if (window.Intercom) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'Intercom' does not exist on type 'Window... Remove this comment to see the full error message
    window.Intercom('boot', {
      app_id: 'y2wzhv2s',
      email: employee.email,
      name: employee.preferred_first_name || employee.full_name,
      user_id: employee.id,
      company_id: company.id,
      user_hash: employee.hmac,
      action_color: company.settings.color_primary,
      background_color: company.settings.color_primary,
      created_at: moment(employee.created).valueOf(),
      isp_url: `https://internal.joinforma.com/employees/${employee.id}/claims`,
      company: {
        id: company.id,
        name: company.company_info.common_name,
        upgraded_at: moment(employee.created).valueOf(),
      },
    });
  }
};
